import type { ProductConfig } from '#types/config/components/product'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    original: 'c-grey-30',
    sale: 'c-brand-3 dark:c-red-60'
  }
} satisfies RecursivePartial<ProductConfig['pricing']>
